import { render } from "./templates/correct.html?vue&type=template&id=45bb438b&external"
import script from "./correct.vue?vue&type=script&lang=js"
export * from "./correct.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./stylesheets/index.scss?vue&type=style&index=0&lang=scss&module=true&external"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__